import React from 'react';
import classNames from 'classnames';
import styles from './flexField.css';

const FlexField = (props) => {
    const { id, focused, error, valid, hasValue, labelCopy, errorCopy, wrapperClass } = props;

    const classes = classNames({
        [styles.field]: true,
        [styles.hasValue]: hasValue,
        [styles.focus]: focused,
        [styles.valid]: valid,
        [styles.error]: error
    });

    return (
        <div className={wrapperClass}>
            <div className={styles.wrapper}>
                <div
                    className={classes} id={id}
                ></div>
                <label
                    className={styles.label}
                    id={`${id}-label`}
                >{labelCopy}</label>
            </div>
            <div>
                {error ?
                    <div className={styles['error-message']}>{errorCopy}</div> : <span>&nbsp;</span>}
            </div>
        </div>
    );
};

export default FlexField;
